import { useBack } from "../http";
import { AudiometryDTO } from "../types/AudiometryDTO";

export class AudiometryService {
	constructor() {}
	axiosInstance = useBack();

	async validateCnpj(cnpj: string) {
		const data = { cnpj: cnpj }
		return await this.axiosInstance.post<AudiometryDTO>(`/audiometry/validate-cnpj`, data);
	}

	async register(audiometry: AudiometryDTO) {
		return await this.axiosInstance.post(`/audiometry/register`, audiometry);
	}
}